import Segment from '@getaccept/lib-shared-new/src/segment';
import { AnalyticsUserTrait } from '@getaccept/lib-shared-new/src/types/analytics';
import Analytics from '@getaccept/lib-shared-new/src/analytics';
import Pendo from '@getaccept/lib-shared-new/src/pendo';
import { getGlobalHandle } from '@getaccept/lib-shared-new/src/helpers';
import type { Language } from '@getaccept/lib-shared-new/src/languages/enums/language';

export const initializeAnalytics = (userId: string, language: Language) => () => {
  Segment.page('Signup');

  if (!userId) {
    return;
  }

  // eslint-disable-next-line no-prototype-builtins
  const isSegmentReady = getGlobalHandle()?.analytics?.hasOwnProperty('initialized');
  const isPendoReady = !!getGlobalHandle()?.pendo;

  if (!isSegmentReady && isPendoReady) {
    Pendo.initialize({
      visitor: {
        [AnalyticsUserTrait.ID]: userId,
        [AnalyticsUserTrait.Language]: language,
      },
    });
  }

  Analytics.identify(userId, {
    [AnalyticsUserTrait.Language]: language,
  });
};
